<template>
  <div class="container">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="发起评估" name="first"></el-tab-pane>
        <el-tab-pane label="评估列表" name="second"></el-tab-pane>
      </el-tabs>

        <!-- 发起评估 -->
    <div  class="content">
      <Sava v-if="activeName === 'first'" @changeTab="savaChange"/>
      <List v-if="activeName === 'second'"/>
    </div>
  </div>
</template>

<script>
import Sava from "./sava.vue";
import List from "./list.vue";

export default {
  components:{
    Sava,
    List
  },

  // 组件状态值
  data () {
   return {
      activeName:'second',
   }
  },
  created(){

  },
  methods:{
    // tab切换
    savaChange(){
      this.activeName ='second'
    },
  }

}
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.container >>>  .el-tabs__nav {
  width: 100%;
}
.container >>> .el-tabs__item {
  width: 50%;
  text-align: center;
  background: #fff;
}
.container >>> .el-tabs__active-bar {
  width: 67px !important;
  left: 50px;
  background-color: #029FD1 !important;
}
.container >>> .el-tabs__header {
  margin: 0;
}
.container >>> .el-tabs__item.is-active  {
  color: #029FD1  ;
}

.content {
  flex: 1;
  margin: 12px;
  border-radius: 8px;
  overflow-y: auto;
  overflow-x:hidden ;
  /* background-color: #fff; */
}


</style>



// WEBPACK FOOTER //
// src/components/assessment/index.vue